<template>
  <div>
    <CModal
      centered
      :show.sync="showModal"
      :title="new_edit_flag ? $t('New branch') : `${$t('Branch')} ${branch_name}`"
      :draggable="false"
      :showFooter="false"
    >
      <CRow class="mt-2">
        <CCol col="10" class="ml-4">
          <label>{{ $t('Branch of insurance') }}</label>
          <CInput
            required
            v-model="branch.branch"
          />
        </CCol>
        <CCol col="10" class="ml-4 mt-1">
          <label>{{ $t('Alias') }}</label>
          <CInput
            required
            v-model="branch.alias"
          />
        </CCol>
        <CCol col="1"/>
        <CCol col="10" class="ml-4 mt-1">
          <label>{{ $t('EN') }}</label>
          <CInput
            required
            v-model="branch.EN"
          />
        </CCol>
      </CRow>
      <CRow class="mt-3 modal-footer">
        <CButton
          class="mz-button v2-mz-btn mr-2 cancel-button"
          color="primary"
          @click="showModal = false"
        >
          {{ $t('Cancel') }}
        </CButton>
        <CButton
          class="mz-button v2-mz-btn mr-2"
          color="primary"
          @click="submitBranch"
        >
          {{ $t('Confirm') }}
        </CButton>
      </CRow>
    </CModal>
    <CCard>
      <CCardHeader>
        {{ $t("Branch of insurance") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="
              $downloadFile({
                url: BRANCHES_ENDPOINTS.export,
              })
            "
          >
            {{ $t("Export") }}
            <i class="ml-2 mz-icon icon-download-alt color-inherit"/>
          </CButton>
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="showNewBranchModal"
          >
            {{ $t("Add") }}
            <i class="ml-2 mz-icon icon-add"/>
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <table-component
          :columns="['branch', 'alias', 'EN', 'date', 'user', 'actions']"
          :headings="{
            branch: $t('Branch'),
            alias: $t('Alias'),
            EN: $t('EN'),
            date: $t('Date'),
            user: $t('User'),
            actions: '',
          }"

          :url="BRANCHES_ENDPOINTS.branches_list"
          :filter-exclude-columns="['actions']"
          ref="table"
        >
          <template #branch="{ row }">
            <CLink @click="() => showEditBranchModal(row)">
              {{ row.branch }}
            </CLink>
          </template>
          <template slot="actions" slot-scope="{ row }">
            <CButton
              @click="() => deleteBranch(row.id_branch)"
              color="danger"
              variant="outline"
            >
              <i class="fa fa-trash-o"/>
            </CButton>
          </template>
        </table-component>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {BRANCHES_ENDPOINTS, BranchesServices} from "@/services/branches";

export default {
  name: "BranchesView",
  data() {
    return {
      BRANCHES_ENDPOINTS,
      showModal: false,
      branch: {},
      new_edit_flag: false,
      branch_name: '',
    };
  },
  methods: {
    showNewBranchModal() {
      this.branch = {}
      this.new_edit_flag = true
      this.showModal = true
    },
    showEditBranchModal(branch) {
      this.branch = {...branch}
      this.branch_name = branch.branch
      this.new_edit_flag = false
      this.showModal = true
    },
    async submitBranch() {
      if (this.new_edit_flag) {
        await BranchesServices.createBranch(this.branch)
      } else {
        await BranchesServices.updateBranch(
          this.branch.id_branch,
          {
            'branch': this.branch.branch,
            'alias': this.branch.alias,
            'EN': this.branch.EN
          }
        )
      }
      this.showModal = false
      this.$refs.table.$refs.table.getData()
    },
    async deleteBranch(id_branch) {
      await BranchesServices.deleteBranch(id_branch)
      this.$refs.table.$refs.table.getData()
    }
  }
}
</script>

<style>
.modal-header {
  color: #fff;
  background-color: #23145f;
  border-color: #23145f;
}

.cancel-button {
  background-color: rgb(187, 188, 209) !important;
  border-color: rgb(187, 188, 209) !important;
}
</style>
